@if (detail){
    @switch (detail?.operation_type_name) {
        @case (OPERATION_TYPE.OCR) {
            <app-operation-detail-tabs-checks-ocr [detail]="detail" />
        }
        @case (OPERATION_TYPE.POL) {
            <app-operation-detail-tabs-checks-pol [detail]="detail" />
        }
        @case (OPERATION_TYPE.DOCUMENTS) {
            <app-operation-detail-tabs-checks-documents [detail]="detail" />
        }
        @case (OPERATION_TYPE.CONNECTIONS || OPERATION_TYPE.EVALUATION || OPERATION_TYPE.FINANCIAL_EVALUATION) {
            <app-operation-detail-tabs-checks-financial-evaluation [detail]="detail" />
        }
        @case (OPERATION_TYPE.BORME) {
            <app-operation-detail-tabs-checks-borme />
        }
        @case (OPERATION_TYPE.FORM) {
            <app-operation-detail-tabs-checks-form [detail]="detail" />
        }
        @default {
            <tec-empty-state
                [title]="'OPERATIONS.DETAIL.TABS.CHECKS.UNSUPPORTED' | translate"
                [size]="'default'"
                [type]="'empty'"
            />
        }
    }
}
